export default [{
  path: '/scene',
  title: 'menu.my_scene',
  icon: 'image'
}, {
  path: '/macro',
  title: 'menu.macro',
  icon: 'call_split'
}, {
  path: '/schedule',
  title: 'menu.schedule',
  icon: 'schedule'
}, {
  path: '/actuator',
  title: 'menu.my_actuator',
  icon: 'lightbulb_outline'
}, {
  path: '/sensor',
  title: 'menu.my_sensor',
  icon: 'nfc'
}, {
  path: '/maintain',
  title: 'menu.maintain',
  icon: 'build'
}, {
  path: '/tracker',
  title: 'menu.tracker',
  icon: 'track_changes'
}, {
  path: '/camera',
  title: 'menu.my_camera',
  icon: 'camera'
}, {
  path: '/labeling',
  title: 'menu.face_labeling',
  icon: 'face'
}, {
  path: '/kanban',
  title: 'menu.my_kanban',
  icon: 'dashboard'
}, {
  path: '/route',
  title: 'menu.route_analysis',
  icon: 'device_hub'
}, {
  path: '/contact',
  title: 'menu.contact',
  icon: 'contacts'
}, {
  path: '/gateway',
  title: 'menu.my_gateway',
  icon: 'router'
}, {
  path: '/map',
  title: 'menu.my_gateway_map',
  icon: 'map'
}];



// WEBPACK FOOTER //
// ./src/helpers/menus.js